import React from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "./ProjectsPage.css";

import img1 from "../assets/projects/1.jpg";
import img2 from "../assets/projects/2.JPG";
import img3 from "../assets/projects/3.jpg";
import img4 from "../assets/projects/4.jpg";
import img5 from "../assets/projects/5.jpg";
import img6 from "../assets/projects/6.jpg";
import img7 from "../assets/projects/7.jpg";
import img8 from "../assets/projects/8.jpg";
import img9 from "../assets/projects/9.jpg";
import img10 from "../assets/projects/10.jpg";
import img11 from "../assets/projects/11.jpg";
import img12 from "../assets/projects/12.jpg";
import img13 from "../assets/projects/13.jpg";

function ProjectsPage() {
  const images = [
    img1,
    img2,
    img3,
    img4,
    img5,
    img6,
    img7,
    img8,
    img9,
    img10,
    img11,
    img12,
    img13,
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
  };

  return (
    <div className="projects-page">
      <h1 className="gallery-title">Project Gallery</h1>

      <div className="gallery-slider-container">
        <Slider {...settings}>
          {images.map((image, index) => (
            <div key={index} className="slide-wrapper">
              <img
                src={image}
                alt={`Project ${index + 1}`}
                className="project-slide-image"
              />
            </div>
          ))}
        </Slider>
      </div>

      <div className="back-btn-wrapper">
        <Link to="/" className="back-home-btn">
          ← Back to Home
        </Link>
      </div>
    </div>
  );
}

export default ProjectsPage;